import { render, staticRenderFns } from "./Countup.vue?vue&type=template&id=947400ee&"
import script from "./Countup.vue?vue&type=script&lang=js&"
export * from "./Countup.vue?vue&type=script&lang=js&"
import style0 from "./Countup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports